// SPDX-License-Identifier: AGPL-3.0-or-later

import Channels from '@app/features/channel/state/Channels';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import GuildReadState from '@app/features/guild/state/GuildReadState';
import Permission from '@app/features/permissions/state/Permission';
import QuickSwitcher from '@app/features/search/state/QuickSwitcher';
import VoiceConnectionManager from '@app/features/voice/engine/VoiceConnectionManager';
import VoiceMediaManager from '@app/features/voice/engine/VoiceMediaManager';
import type {Channel} from '@fluxer/schema/src/domains/channel/ChannelSchemas';

type ChannelUpdatePayload = Partial<Channel> & {
	id: string;
	type: number;
};

interface ChannelUpdateBulkPayload {
	channels: Array<ChannelUpdatePayload>;
}

export function handleChannelUpdateBulk(data: ChannelUpdateBulkPayload, _context: GatewayHandlerContext): void {
	for (const payload of data.channels) {
		const existing = Channels.getChannel(payload.id);
		const channel = existing != null ? existing.withUpdates(payload) : (payload as Channel);
		Channels.handleChannelCreate({channel});
		Permission.handleChannelUpdate(payload.id);
		GuildReadState.handleGenericUpdate(payload.id);
		if (payload.id === VoiceConnectionManager.channelId && payload.bitrate !== undefined) {
			void VoiceMediaManager.refreshMicrophonePublishSettings(VoiceConnectionManager.room, payload.id);
		}
	}
	QuickSwitcher.recomputeIfOpen();
}
